import React, {useEffect, useRef} from 'react';
import _ from 'lodash';
import {observer} from 'mobx-react';

import {Department} from '../../models/middleware';
import {findDepartment} from '../../navigation/linking';
import {RangeStore} from '../../stores/rangeStore';
import {useStores} from '../../stores/use-stores';
import {ProductCarousel} from '../ProductCarousel';

const DEFAULT_DEPARTMENT = 'Specials';

type DepartmentCarouselProps = {
  /**
   * Show products from this department
   */
  departmentName?: string;
  onSeeAllPress?: (department: Department) => void;
};

const DepartmentCarousel = observer(
  ({
    onSeeAllPress,
    departmentName = DEFAULT_DEPARTMENT,
  }: DepartmentCarouselProps) => {
    const rangeStoreRef = useRef(new RangeStore(useStores()));
    const rangeStore = rangeStoreRef.current;
    const department = findDepartment(departmentName);

    useEffect(() => {
      if (department) {
        rangeStore.selectDepartment(department);
        rangeStore.loadRangeLines();
      }
    }, [department, rangeStore]);

    return (
      <ProductCarousel
        title={_.toUpper(rangeStore.selectedDepartment?.name || departmentName)}
        onSeeAllPress={
          onSeeAllPress
            ? () => {
                if (department) {
                  onSeeAllPress?.(department);
                }
              }
            : undefined
        }
        isLoading={rangeStore.isLoadingDepartmentLines}
        data={rangeStore.departmentLines}
      />
    );
  },
);

export default DepartmentCarousel;
